import { type IntegrationSettingsIntercomCheckboxes } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/types'

export const INTERCOM_SYNC_CHECKBOX_KEYS: IntegrationSettingsIntercomCheckboxes[] = [
  'sync_update',
  'sync_save',
]
